export default "__VITE_ASSET__bfKm5ZdN__"